<template>
  <div>
    <SlideCarousels
      :item-total-count="items.length"
      :items="items"
      :breakpoints="breakpoints"
      :slide-number="3"
      :fixed-height="fixedHeight"
      :gap="3"
    >
      <template v-slot:slides>
        <VueperSlide v-for="(item, index) in items" :key="index">
          <template #content>
            <div ref="top">
              <FacilityItem :item="item" @ImgLoaded="refreshHeight" />
            </div>
          </template>
        </VueperSlide>
      </template>
    </SlideCarousels>
  </div>
</template>

<script>
import SlideCarousels from '@/components/SlideCarousels';
import {VueperSlide} from 'vueperslides';
import FacilityItem from '@/pages/MainPage/Components/FacilityItem';

export default {
  name: 'FacilitySubItems',
  data() {
    return {
      fixedHeight: '0px',
      windowWidth: 0,
      items: null,
      items_ko: [
        {
          image: require('@/assets/images/Annex/main-facility-swimming.jpg'),
          title: 'SWIMMING POOL',
          desc: '창 밖의 풍경을 감상하며 온 가족이 즐길 수 있는 실내 수영장',
          url: 'Swimmingpool',
        },
        {
          image: require('@/assets/images/Annex/main-facility-lounge.jpg'),
          title: 'RESTAURANT',
          desc: '로맨틱한 호수뷰가 펼쳐지는 레스토랑',
          url: 'Restaurant',
        },
        {
          image: require('@/assets/images/Annex/main-facility-bookcafe.jpg'),
          title: 'BOOK CAFE',
          desc: '1,000여권의 장서가 비치된 라이브러리 카페',
          url: 'Bookcafe',
        },
        {
          image: require('@/assets/images/Annex/main-facility-courtyard.jpg'),
          title: 'COURTYARD',
          desc: '디아넥스에서 만나는 작은 제주의 숲',
          url: 'Joongjung',
        },
        {
          image: require('@/assets/images/Annex/main-facility-sports.jpg'),
          title: 'SPORTS HALL',
          desc: '다양한 스포츠와 오락게임을 즐길 수 있는 공간',
          url: 'Sportshall',
        },
        {
          image: require('@/assets/images/Annex/main-facility-golf-tang.jpg'),
          title: 'GOLF TANG TANG',
          desc: '푸른 잔디 위 누구나 즐길 수 있는 미니 그라운드 골프장',
          url: 'Golftangtang',
        },
        {
          image: require('@/assets/images/Annex/main-facility-tennis.jpg'),
          title: 'TENNIS COURT',
          desc: 'US OPEN 국제규격의 넓고 쾌적한 실내 테니스장',
          url: 'Tenniscourt',
        },
        {
          image: require('@/assets/images/Annex/main-facility-conference.jpg'),
          title: 'CONFERENCE ROOM',
          desc: '성공적인 비즈니스를 위한 회의 공간',
          url: 'Conferenceroom',
        },
        {
          image: require('@/assets/images/Annex/main-facility-p-store.jpg'),
          title: 'P-STORE',
          desc: '고객의 편의를 위한 24시 스토어',
          url: 'Pstore',
        },
      ],
      items_en: [
        {
          image: require('@/assets/images/Annex/main-facility-swimming.jpg'),
          title: 'SWIMMING POOL',
          desc: 'The indoor swimming pool for the whole family to enjoy with the scenery outside the window',
          url: 'Swimmingpool',
        },
        {
          image: require('@/assets/images/Annex/main-facility-lounge.jpg'),
          title: 'RESTAURANT',
          desc: 'The restaurant with the romantic view of the lake',
          url: 'Restaurant',
        },
        {
          image: require('@/assets/images/Annex/main-facility-bookcafe.jpg'),
          title: 'BOOK CAFE',
          desc: 'The library café with a collection of 1,000 books',
          url: 'Bookcafe',
        },
        {
          image: require('@/assets/images/Annex/main-facility-courtyard.jpg'),
          title: 'COURTYARD',
          desc: 'A small forest in Jeju found at THE ANNEX',
          url: 'Joongjung',
        },
        {
          image: require('@/assets/images/Annex/main-facility-sports.jpg'),
          title: 'SPORTS HALL',
          desc: 'A place to enjoy various sports and games',
          url: 'Sportshall',
        },
        {
          image: require('@/assets/images/Annex/main-facility-golf-tang.jpg'),
          title: 'GOLF TANG TANG',
          desc: 'The mini-ground golf course that anyone can enjoy on the green grass',
          url: 'Golftangtang',
        },
        {
          image: require('@/assets/images/Annex/main-facility-tennis.jpg'),
          title: 'TENNIS COURT',
          desc: 'Broad and comfortable indoor tennis court built to US OPEN international standard',
          url: 'Tenniscourt',
        },
        {
          image: require('@/assets/images/Annex/main-facility-conference.jpg'),
          title: 'CONFERENCE ROOM',
          desc: 'The space for conference for successful business',
          url: 'Conferenceroom',
        },
        {
          image: require('@/assets/images/Annex/main-facility-p-store.jpg'),
          title: 'P-STORE',
          desc: '24-hour-open store for customer convenience',
          url: 'Pstore',
        },
      ],
      items_jp: [
        {
          image: require('@/assets/images/Annex/main-facility-swimming.jpg'),
          title: 'SWIMMING POOL',
          desc: '窓の外の風景を鑑賞しながらご家族で楽しめる室内プール',
          url: 'Swimmingpool',
        },
        {
          image: require('@/assets/images/Annex/main-facility-lounge.jpg'),
          title: 'RESTAURANT',
          desc: 'ロマンチックなレイクビューが広がるレストラン',
          url: 'Restaurant',
        },
        {
          image: require('@/assets/images/Annex/main-facility-bookcafe.jpg'),
          title: 'BOOK CAFE',
          desc: '1,000冊以上の蔵書のあるライブラリーカフェ',
          url: 'Bookcafe',
        },
        {
          image: require('@/assets/images/Annex/main-facility-courtyard.jpg'),
          title: 'COURTYARD',
          desc: 'ジ・アネックスホテルで出会う小さな済州の森',
          url: 'Joongjung',
        },
        {
          image: require('@/assets/images/Annex/main-facility-sports.jpg'),
          title: 'SPORTS HALL',
          desc: '様々なスポーツとゲームが楽しめるスペース',
          url: 'Sportshall',
        },
        {
          image: require('@/assets/images/Annex/main-facility-golf-tang.jpg'),
          title: 'GOLF TANG TANG',
          desc: '緑の芝の上でどなたでも楽しめるミニグラウンドゴルフ場',
          url: 'Golftangtang',
        },
        {
          image: require('@/assets/images/Annex/main-facility-tennis.jpg'),
          title: 'TENNIS COURT',
          desc: 'USオープン国際規格の広く快適な室内テニスコート',
          url: 'Tenniscourt',
        },
        {
          image: require('@/assets/images/Annex/main-facility-conference.jpg'),
          title: 'CONFERENCE ROOM',
          desc: 'ビジネス成功のためのミーティングスペース',
          url: 'Conferenceroom',
        },
        {
          image: require('@/assets/images/Annex/main-facility-p-store.jpg'),
          title: 'P-STORE',
          desc: '便利にご利用いただける24時間ストア',
          url: 'Pstore',
        },
      ],
      breakpoints: {
        992: {
          bullets: false,
          arrows: false,
          visibleSlides: 2,
          touchable: false,
          disableArrowsOnEdges: true,
          fade: true,
          animation: false,
        },

        500: {
          bullets: false,
          arrows: false,
          visibleSlides: 1,
          touchable: false,
          disableArrowsOnEdges: true,
          fade: true,
          animation: false,
        },
      },
    };
  },
  components: {
    SlideCarousels,
    VueperSlide,
    FacilityItem,
  },
  watch: {
    windowWidth(newHeight, oldHeight) {
      this.refreshHeight();
    },
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.refreshHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    refreshHeight() {
      this.$nextTick(() => {
        console.log('HEIGHT>>>!!!FS', this.$refs.top);
        if (this.$refs.top !== undefined) {
          let px = this.$refs.top[0].clientHeight;
          this.fixedHeight = `${px + 20}px`;
          console.log('HEIGHT>>>!!!FS', this.fixedHeight);
        }
      });
    },
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.items = this.items_ko;
      } else if (newVal === 'en') {
        this.items = this.items_en;
      } else if (newVal === 'ja') {
        this.items = this.items_jp;
      } else {
        this.items = this.items_ko;
      }
    },
  },
};
</script>

<style scoped lang="scss">
h2 {
  padding-top: 50px;
  height: 110px;
  text-align: center;
  color: #222222;
  font-family: 'Nanum Gothic', sans-serif;
  font-size: 1.6em !important;
}
</style>
